import { EntityService } from 'utils/entityService';
import { SavedFilterModel } from 'models';
import request, { Methods } from 'utils/request';
import { Mock } from 'utils/mockDecorator';

class FilterService extends EntityService {
  constructor() {
    super('user-filters');
  }

  @Mock(() => import('mock/filters').then((m) => m.MOCK_SAVED_FILTERS))
  async getSavedFilters(pageName: string) {
    return request<SavedFilterModel[]>({
      method: Methods.GET,
      resource: `${this.resource}/resource/${pageName}`,
    });
  }

  @Mock((filterData: Pick<SavedFilterModel, 'filter' | 'name' | 'resource'>) =>
    import('mock/filters').then((m) => m.createMockSavedFilter(filterData))
  )
  async saveFilter(filterData: Pick<SavedFilterModel, 'filter' | 'name' | 'resource'>) {
    return request<SavedFilterModel>({
      method: Methods.POST,
      resource: this.resource,
      data: filterData,
    });
  }

  @Mock(() => undefined)
  async deleteFilter(id: ID) {
    return request({
      method: Methods.DELETE,
      resource: `${this.resource}/${id}`,
    });
  }
}

export const filterService = new FilterService();
